import { createRouter, createRoute } from '@tanstack/react-router';
import { rootRoute } from './App';
import { landingRoute } from './pages/Landing.route';
import { homeRoute } from './pages/Home.route';
import { authenticatedRoute } from './pages/AuthenticatedView.route';
import { NotFound } from './pages/NotFound.page';
import type { RouterContext } from './types/route.types';
import { ServerError } from './pages/ServerError.page';
import { FullPageLoader } from './components/FullPageLoader';

import { reviewSummaryRoute } from './features/review/pages/ReviewSummary.route';
import { startReviewRoute } from './features/review/pages/StartReview.route';
import { sourcesRoute } from './features/sources/pages/Sources.route';
import { deduplicationRoute } from './features/deduplication/pages/Deduplication.route';
import { publishedReviewRoute } from './features/published/pages/PublishedReview.route';
import { publishedRecordRoute } from './features/published/pages/PublishedRecord.route';

const authenticatedRouteWithChildren = authenticatedRoute.addChildren([
    landingRoute,
    startReviewRoute,
    reviewSummaryRoute,
    sourcesRoute,
    deduplicationRoute
]);

export const errorRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/error",
    component: () => <ServerError error={Error('Invalid route.')} />,
});

export const routeTree = rootRoute.addChildren([
    homeRoute,
    publishedReviewRoute,
    publishedRecordRoute,
    authenticatedRouteWithChildren,
    errorRoute,
]);

// Create a new router instance
export const createAppRouter = (context: RouterContext) => {
    return createRouter({
        routeTree,
        defaultPreload: 'intent',
        context: context,
        defaultNotFoundComponent: () => <NotFound />,
        defaultPendingComponent: () => <FullPageLoader />,
        defaultErrorComponent: ({ error }) => {
            return <ServerError error={error} />;
        },
        scrollRestoration: true
    })
}